import { _ as r } from "../internals/export.js";
import { p as n } from "../internals/promise-native-constructor.js";
import { f as t } from "../internals/fails.js";
import { g as i } from "../internals/get-built-in.js";
import { i as o } from "../internals/is-callable.js";
import { s } from "../internals/species-constructor.js";
import { p as e } from "../internals/promise-resolve.js";
import { d as a } from "../internals/define-built-in.js";
var l = n && n.prototype;
if (r({
  target: "Promise",
  proto: !0,
  real: !0,
  forced: !!n && t(function () {
    l.finally.call({
      then: function then() {}
    }, function () {});
  })
}, {
  finally: function _finally(r) {
    var n = s(this, i("Promise")),
      t = o(r);
    return this.then(t ? function (t) {
      return e(n, r()).then(function () {
        return t;
      });
    } : r, t ? function (t) {
      return e(n, r()).then(function () {
        throw t;
      });
    } : r);
  }
}), o(n)) {
  var f = i("Promise").prototype.finally;
  l.finally !== f && a(l, "finally", f, {
    unsafe: !0
  });
}